<template>
  <div class="join-screen">
    <h1>Track shared expenses. <br/> See who owes what.</h1>
    <h2>What's your name?</h2>
    <div v-for="(entity, index) in entities" class="entity" :key="index">
      <input
        v-for="(person, index) in entity.people"
        type="text"
        maxlength="26"
        v-model="person.name"
        :key="index"
        :class="{ error: !isValid('name')}"
        @keydown.enter="tryJoinGig"
        autofocus
      />
      <h4 class="add-others" @click="addPeople(index)">+ Add others to entity</h4>
    </div>
    <h4 class="add-others" @click="addEntity">+ Add others</h4>
    <button type="button" @click="tryJoinGig">
      Join gig
    </button>
    <div v-if="hasExistingEntities" class="join-as-box">
      <p>or</p>
      <template v-for="entity in existingEntities">
        <h4 class="join-as-name" v-for="person in entity.people" :key="person.id" @click="joinAs(person.id)">
          Join as {{ person.name }}
        </h4>
      </template>
    </div>
  </div>
</template>

<script>
import { db } from '../db.js';

export default {
  name: 'JoinScreen',
  props: {
    gigId: String,
    suggestedName: String,
  },
  data() {
    return {
      existingEntities: [],
      entities: [
        {
          people: [
            { name: this.prefillName() },
          ],
        },
      ],
      formErrors: [],
    };
  },
  computed: {
    hasExistingEntities() {
      return this.gigId && this.existingEntities.length > 0;
    },
  },
  methods: {
    prefillName() {
      return this.suggestedName || localStorage.lastUsedName || '';
    },
    addEntity() {
      this.entities.push({ people: [{ name: '' }] });
    },
    addPeople(index) {
      this.entities[index].people.push({ name: '' });
    },
    joinGigById(gigId) {
      const firstName = this.entities[0].people[0].name;
      const gig = db.collection('gigs').doc(gigId);
      const entitiesCollection = gig.collection('entities');
      const entities = JSON.parse(JSON.stringify(this.entities));
      const nonEmptyEntities = entities.filter(entity => entity.people.some(person => person.name));
      const allPeoplePromises = [];
      const entitiesPromises = [];
      nonEmptyEntities.forEach(entity => {
        const peoplePromises = entity.people
          .filter(person => person.name)
          .map(person => 
            gig.collection('people').add(person)
          );
        allPeoplePromises.push(...peoplePromises);
        Promise.all(peoplePromises).then(refs => {
          refs.forEach((ref, index) => {
            entity.people[index] = ref;
          });
          entitiesPromises.push(entitiesCollection.add(entity));
        });
      });
      Promise.all(allPeoplePromises).then(() => {
        Promise.all(entitiesPromises).then(docRefs => {
          //TODO consider a library or a wrapper for localStorage
          let gigMap = JSON.parse(localStorage.gigMap);
          docRefs.forEach((docRef) => {
            gigMap[gigId] = docRef.id;
            // TODO: What is expected RHS? Should it be first person id?
          });
          localStorage.gigMap = JSON.stringify(gigMap);
          localStorage.lastUsedName = firstName;
          this.$router.push('/' + gigId);
        });
      });
    },
    joinGig() {
      if (this.gigId) {
        this.joinGigById(this.gigId);
      } else {
        db.collection('gigs').add({}).then(docRef => {
          const gigId = docRef.id;
          this.joinGigById(gigId);
        });
      }
    },
    tryJoinGig() {
      this.validate();
      if (this.isValid()) {
        this.joinGig();
      }
    },
    joinAs(memberId) {
      //TODO refactor - looks like duplication with Join method
      const gigMap = JSON.parse(localStorage.gigMap);
      gigMap[this.gigId] = memberId;
      localStorage.gigMap = JSON.stringify(gigMap);
      this.$router.push('/' + this.gigId);
    },
    validate() {
      this.formErrors = [];
      if (this.entities.every(entity => entity.people.every(person => !person.name))) {
        this.formErrors.push({ name: 'At least one name must not be empty' });
      }
    },
    isValid(key) {
      if (key) {
        return this.formErrors.filter(error => key in error).length === 0;
      } else {
        return this.formErrors.length === 0;
      }
    },
  },
  watch: {
    gigId: {
      immediate: true,
      handler(gigId) {
        let gig;
        if (gigId) {
          gig = db.collection('gigs').doc(gigId);
        } else {
          gig = db.collection('gigs').doc();
        }
        this.$bind('existingEntities', gig.collection('entities'));
      }
    },
  },
}
</script>

<style scoped>
.join-screen {
  padding-top: 100px;
  text-align: center;
}
h1, h2 {
  color: #6d547e;
}
h1 {
  margin-top: 0;
}
h4 {
  cursor: pointer;
  color: #6d547e;
}
input {
  margin-top: 10px;
  padding: 10px;
  border-radius: 10px;
  outline: none;
  font-size: 24px;
  border: 1px solid #6d547e;
}
input.error {
  border: 1px solid red;
}
input:first-child {
  margin-top: 0;
}
button {
  padding: 10px 15px;
  border-radius: 8px;
  border: none;
  background-color: #6d547e;
  font-size: 18px;
  color: white;
  outline: none;
}
.join-as-box p {
  margin-bottom: 0;
  color: #a0a0a0;
}
.join-as-box h4:first-child {
  margin-top: 10px;
}
.entity {
  border: 1px solid lightgrey;
  border-radius: 1em;
  padding: .8em .8em 0;
  width: min-content;
  background: #fff;
  margin: 0 auto 1em;
}
.add-others {
  margin: 1em 0;
}
</style>
